import React from "react";
import { useParams } from "react-router-dom";
import Theme404 from "../../layout/404";

import order_list from "./order.list";
import order_edit from "./order.edit";

/**
 *   Create index file for order
 */

export default function List_order() {
  let useParam = {} as any;
  useParam = useParams();
  let Param = useParam.slug || "list";

  let ActualPage: any;
  switch (Param) {
    case "list":
      ActualPage = order_list;
      break;

    case "edit":
      ActualPage = order_edit;
      break;

    case "new":
      ActualPage = order_edit;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <>{<ActualPage />}</>;
}

